<!DOCTYPE html>
<html lang="en">
  <head>
    <title>Transaction Reference</title>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <link
      rel="icon"
      type="image/png"
      href="https://fispoke-dev.firstrate-wealthtech.com/assets/images/favicon.ico"
    />
    <link
      href="https://cdnjs.cloudflare.com/ajax/libs/primeicons/3.0.0/primeicons.min.css"
      rel="stylesheet"
      type="text/css"
    />
  </head>

  <body>
    <div class="txn-approval-page">
      <div class="txn-approval-container">
        @if (step === 'loading') {
          <div class="txn-loading">
            <i class="pi pi-spin pi-spinner"></i>
            <span>Loading your transaction...</span>
          </div>
        }

        @if (step === 'error') {
          <div class="status-banner status-banner--error">
            <div class="status-banner__icon">
              <i class="pi pi-exclamation-circle"></i>
            </div>
            <div>
              <p class="status-banner__title">This transaction link isn't valid</p>
              <p class="status-banner__subtitle">{{ loadError }}</p>
            </div>
          </div>
        }

        @if (step === 'result') {
          @if (isSuccessBanner()) {
            <div class="status-banner status-banner--success">
              <div class="status-banner__icon">
                <i class="pi pi-check"></i>
              </div>
              <div>
                <p class="status-banner__title">{{ getBannerTitle() }}</p>
                <p class="status-banner__subtitle">{{ getBannerSubtitle() }}</p>
              </div>
            </div>
          } @else {
            <div class="status-banner status-banner--error">
              <div class="status-banner__icon">
                <i class="pi pi-exclamation-circle"></i>
              </div>
              <div>
                <p class="status-banner__title">{{ getBannerTitle() }}</p>
                <p class="status-banner__subtitle">{{ getBannerSubtitle() }}</p>
              </div>
            </div>
          }
        }

        @if (step === 'details' || step === 'otp' || (step === 'result' && v_tran_status !== 'Cancelled')) {
          <div class="txn-reference-label">
            <i class="pi pi-folder-open"></i>
            <span>Transaction Reference</span>
          </div>

          <div class="txn-amount-card">
            <div>
              <div class="txn-amount-card__label">Transaction Amount</div>
              <div class="txn-amount-card__value">
                {{
                  (withdrawCashMomentData?.TransferAmount
                    | currency: 'USD') ?? '--'
                }}
              </div>
            </div>
          </div>

          <div class="detail-card detail-card--sender">
            <div class="detail-card__header">
              <h3 class="detail-card__title">{{ transferType === 'DEPOSIT' ? 'Sender Details' : 'From Account' }}</h3>
              <span class="detail-card__badge detail-card__badge--from">FROM</span>
            </div>
            <div class="detail-grid">
              @if (transferType === 'DEPOSIT') {
                <div class="detail-field">
                  <span class="detail-field__label">Account Name</span>
                  <span class="detail-field__value">{{ externalParty?.name ?? '--' }}</span>
                </div>
                <div class="detail-field">
                  <span class="detail-field__label">Account Number</span>
                  <span class="detail-field__value">{{ externalParty?.accountNumber ?? '--' }}</span>
                </div>
                <div class="detail-field">
                  <span class="detail-field__label">Bank Name</span>
                  <span class="detail-field__value">{{ externalParty?.bankName ?? '--' }}</span>
                </div>
                <div class="detail-field">
                  <span class="detail-field__label">Routing Number</span>
                  <span class="detail-field__value">{{ externalParty?.routingNumber ?? '--' }}</span>
                </div>
              } @else {
                <div class="detail-field">
                  <span class="detail-field__label">Account Name</span>
                  <span class="detail-field__value">{{ hysaParty?.name ?? '--' }}</span>
                </div>
                <div class="detail-field">
                  <span class="detail-field__label">Account Number</span>
                  <span class="detail-field__value">{{ hysaParty?.accountNumber ?? '--' }}</span>
                </div>
              }
            </div>
          </div>

          <div class="detail-card detail-card--recipient">
            <div class="detail-card__header">
              <h3 class="detail-card__title">{{ transferType === 'WITHDRAWAL' ? 'Recipient Details' : 'To Account' }}</h3>
              <span class="detail-card__badge detail-card__badge--to">TO</span>
            </div>
            <div class="detail-grid">
              @if (transferType === 'WITHDRAWAL') {
                <div class="detail-field">
                  <span class="detail-field__label">Account Name</span>
                  <span class="detail-field__value">{{ externalParty?.name ?? '--' }}</span>
                </div>
                <div class="detail-field">
                  <span class="detail-field__label">Account Number</span>
                  <span class="detail-field__value">{{ externalParty?.accountNumber ?? '--' }}</span>
                </div>
                <div class="detail-field">
                  <span class="detail-field__label">Bank Name</span>
                  <span class="detail-field__value">{{ externalParty?.bankName ?? '--' }}</span>
                </div>
                <div class="detail-field">
                  <span class="detail-field__label">Routing Number</span>
                  <span class="detail-field__value">{{ externalParty?.routingNumber ?? '--' }}</span>
                </div>
              } @else {
                <div class="detail-field">
                  <span class="detail-field__label">Account Name</span>
                  <span class="detail-field__value">{{ hysaParty?.name ?? '--' }}</span>
                </div>
                <div class="detail-field">
                  <span class="detail-field__label">Account Number</span>
                  <span class="detail-field__value">{{ hysaParty?.accountNumber ?? '--' }}</span>
                </div>
              }
            </div>
          </div>
        }

        @if (step === 'details') {
          @if (loadError) {
            <div class="txn-inline-error">{{ loadError }}</div>
          }
          <div class="txn-actions">
            <button type="button" class="txn-btn txn-btn--secondary" [disabled]="isCancelling || isResendingOtp"
              (click)="onCancelClick()">
              {{ isCancelling ? 'Cancelling...' : 'Cancel' }}
            </button>
            <button type="button" class="txn-btn txn-btn--primary" [disabled]="isCancelling || isResendingOtp"
              (click)="onContinueClick()">
              {{ isResendingOtp ? 'Sending code...' : 'Continue' }}
            </button>
          </div>
        }

        @if (step === 'otp') {
          <div class="txn-otp-card">
            <div class="txn-otp-icon">
              <i class="pi pi-lock"></i>
            </div>
            <div class="txn-otp-title">Verify it's you</div>
            <div class="txn-otp-subtitle">
              We sent a 6-digit code to approve this transfer. Enter it below to continue.
            </div>

            <div class="txn-otp-single-row">
              <input type="text" inputmode="numeric" pattern="[0-9]*" maxlength="6" autocomplete="one-time-code"
                class="txn-otp-single-input" name="otp" [(ngModel)]="otp" (ngModelChange)="onOtpValueChange($event)" />
            </div>

            @if (otpError) {
              <div class="txn-otp-error">{{ otpError }}</div>
            }

            <div class="txn-otp-resend">
              Didn't get it?
              <button type="button" class="txn-otp-resend-link" [disabled]="isResendingOtp" (click)="resendOtp()">
                {{ isResendingOtp ? 'Sending...' : 'Send a new code' }}
              </button>
            </div>

            <button type="button" class="txn-btn txn-btn--primary txn-otp-submit"
              [disabled]="isSubmittingOtp || (otp?.length ?? 0) < 6" (click)="onOtpSubmit()">
              {{ isSubmittingOtp ? 'Approving...' : 'Approve transfer' }}
            </button>
          </div>
        }
      </div>
    </div>
  </body>
</html>
